<template>
  <div :class="{ 'configuration-card': true }">
    <figure class="responsive-image">
      <slot name="image" />
    </figure>
    <div class="content" v-stack-y:sm>
      <h3>
        <slot name="title" />
      </h3>
      <slot />
      <slot name="link" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.configuration-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  max-width: 540px;
  overflow: hidden;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  text-align: left;
  background: white;
  opacity: 0;
  transform: scale3d(0.975, 0.975, 1);
  animation: popup 250ms ease forwards;

  @media screen and (min-width: 1080px) {
    flex-direction: row;
  }

  h3 {
    @include text('base', 'strong');
    color: $color-black;
  }

  .responsive-image {
    position: relative;

    &::before {
      content: '';
      display: block;
      padding-bottom: 100%;
    }

    img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;

    p {
      @include text('base');
      max-width: 420px;
      min-height: 48px;
      color: $color-gray-700;
    }
  }

  @media screen and (min-width: 1080px) {
    .responsive-image {
      width: 200px;
      min-width: 200px;
      height: 200px;
    }
    .content {
      width: 400px;
      height: auto;

      p {
        max-width: 220px;
      }
    }
  }

  @supports (display: grid) {
    .responsive-image {
      flex: 1 2 auto;
    }
    .content {
      flex: 2 1 auto;
    }

    @media screen and (min-width: 1080px) {
      .content {
        width: unset;
        max-width: max-content;
        height: unset;

        p {
          max-width: unset;
        }
      }
    }
  }

  @keyframes popup {
    to {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
}
</style>
